<pos-app-spinner [show]="loading"></pos-app-spinner>
<div class="pb-5">
  <div class="text-center">
    <h3 class="pt-3 arb-large-heading">Manage Help Component</h3>
  </div>
  <div class="col pt-2 mx-4">
    <div class="pb-2 d-flex">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div>
          <input type="text" class="form-control" [(ngModel)]="searchValue" placeholder="Quick filter..." />
        </div>
        <div>
          <button class="btn btn-primary" (click)="onCreateNew()">ADD NEW</button>
        </div>
      </div>
    </div>
    <ag-grid-angular
      #agGrid
      class="ag-theme-balham datagrid"
      [rowData]="rowData"
      [context]="context"
      [frameworkComponents]="frameworkComponents"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      [domLayout]="'autoHeight'"
      [pagination]="true"
      [paginationPageSize]="20"
      [quickFilterText]="searchValue"
    ></ag-grid-angular>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">
      {{ isEditMode ? 'EDIT HELP COMPONENT' : isCreateNew ? 'ADD HELP COMPONENT' : '' }}
    </h3>
  </div>
  <div>
    <div class="modal-body">
      <central-app-manage-help-component
        [isEditMode]="isEditMode"
        [isCreateNew]="isCreateNew"
        [helpComponentDetails]="helpComponentDetails"
        (closeActiveModal)="closeModal()"
        (formSubmit)="saveAdd($event)"
        [helpComponentRoles]="helpComponentRoles"
      >
      </central-app-manage-help-component>
    </div>
  </div>
</ng-template>
